module.exports = __webpack_public_path__ + "static/media/pdeu_logo.c4c76eb1.png";